import React from "react";
import { CheckoutModal, IconArrowLeft, IconDownload } from "kompare-ui-library";
import { i18n, mediaQuery } from "src/common";
import { Button, Flex, Label, Text } from 'src/components';
import { colors } from "src/theme";
import styled from "@emotion/styled";

const TextStyle = styled(Text)({
  marginBottom: 32,
})

const TextStyle2 = styled(Text)({
  marginLeft: 8,
})

const FlexContainerStyle = styled(Flex)({
  marginBottom: 32,
})

const ButtonStyle = styled(Button)({
  [mediaQuery('mobile')]: {
    width: 250,
    alignSelf: 'flex-end',
  }
})

const LabelStyle = styled(Label)({
  marginBottom: 32,
})

const LinkContainerStyle = styled.a({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  cursor: 'pointer',
})

export interface TermsAndConditionsSectionInterface {
  sectionTitle?: string;
  sectionContent?: Array<{ text?: string, action?: () => void }>
}

export interface TermsAndConditionsProps {
  open?: boolean;
  title?: string;
  subtitle?: string;
  sections?: Array<TermsAndConditionsSectionInterface>;
  onClose?: () => void;
  onBackToPaymentButtonPress?: () => void;
}

export const TermsAndConditionsModal = ({ open = false, title = i18n.t('components.modals.termsAndConditionsModal.title'), subtitle= i18n.t('components.modals.termsAndConditionsModal.subtitle'), sections, onClose, onBackToPaymentButtonPress }: TermsAndConditionsProps) => (
  <CheckoutModal title={title} open={open} onClose={() => onClose && onClose()}>
    <Flex vertical>
      <TextStyle type="base">{subtitle}</TextStyle>
      {sections?.map((section, sectionIndex) => (
        <FlexContainerStyle key={sectionIndex} vertical>
          <LabelStyle type={"medium"}>{section.sectionTitle}</LabelStyle>
          {section.sectionContent?.map((sectionContent, contentIndex) => (
            <FlexContainerStyle key={contentIndex}>
              <LinkContainerStyle onClick={() => sectionContent.action && sectionContent.action()}>
                <IconDownload />
                <TextStyle2 color={colors.text3} type="base" bold>{sectionContent.text}</TextStyle2>
              </LinkContainerStyle>
            </FlexContainerStyle>
          ))}
        </FlexContainerStyle>
      ))}
      <ButtonStyle onClick={() => onBackToPaymentButtonPress && onBackToPaymentButtonPress()} size="large" btnType="black" iconPosition="left" text={i18n.t('components.modals.termsAndConditionsModal.backToPaymentButton')}>{<IconArrowLeft />}</ButtonStyle>
    </Flex>
  </CheckoutModal>
);
